import React from 'react'
import { useNavigate } from 'react-router-dom';
import Icon from '../resources/logo.png';

export const Logo = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    //navigate("/")
    window.location.replace('https://enjoysushi.es')
  }
  return (
    <div className="flex md:flex-row justify-content-start flex-wrap">
        <img src={Icon} alt="Icono" width = "100" onClick={()=> handleClick()}></img>
        <h1 onClick={()=> handleClick()} style={{
            marginLeft: '10px',
            color: '#F0E3AC',
            backgroundColor: '#284432',
            fontStyle: 'italic',
        }}>Enjoy Sushi</h1>
    </div>
  )
}
